import type { BynderImage } from '@workspace/interfaces';

export interface PictureImageSource {
  alt?: string | null;
  bynderImage?: BynderImage | null;
}

export type PictureSource = PictureImageSource | BynderImage;

export const getBynderAsset = (image: PictureSource): BynderImage | undefined => {
  const withBynder = image as PictureImageSource;
  if (withBynder.bynderImage) return withBynder.bynderImage;

  const bynder = image as BynderImage;
  if (bynder._type === 'bynder.asset' || 'selectedUrl' in image || 'databaseId' in image) {
    return bynder;
  }

  return undefined;
};

export interface ResolvedSource {
  baseUrl: string;
  isBynder: boolean;
  isSvg: boolean;
}

export const resolveSource = (image: PictureSource): ResolvedSource => {
  const bynder = getBynderAsset(image);
  const bynderUrl = bynder?.selectedUrl ?? bynder?.url ?? bynder?.datUrl ?? bynder?.previewUrl ?? '';

  return { baseUrl: bynderUrl, isBynder: !!bynderUrl, isSvg: !!bynder?.isSvg };
};

export const resolveAlt = (image: PictureSource, alt?: string): string =>
  alt ?? getBynderAsset(image)?.alt ?? (image as PictureImageSource).alt ?? '';

export const buildDatUrl = (baseUrl: string, width: number, height: number): string => {
  if (!baseUrl) return '';

  const ioMatch = baseUrl.match(/[?&]io=transform:([^&]*)/);
  if (ioMatch) {
    const params = ioMatch[1].split(',').filter((part) => part && !/^(width|height):/.test(part.trim()));
    const nextIo = `io=transform:${[...params, `width:${width}`, `height:${height}`].join(',')}`;
    return baseUrl.replace(/([?&])io=transform:[^&]*/, `$1${nextIo}`);
  }

  const joiner = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${joiner}io=transform:fill,width:${width},height:${height}`;
};
